import NotificationsSystemic from './NotificationsSystemic.vue';

export default NotificationsSystemic;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/notification/views/systemic/index.ts